import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from '../../../pages/account/services/account.service';
import { HiringService } from '../../../pages/hiring/services/hiring.service';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
  selector: 'app-apply-with-pin-modal',
  templateUrl: './apply-with-pin-modal.component.html',
  styleUrls: ['./apply-with-pin-modal.component.css'],
})
export class ApplyWithPinModalComponent {
  @Input() data: any;
  formData: any = {};
  alert: any;

  constructor(
    private hiringService: HiringService,
    private router: Router,
    public activeModal: NgbActiveModal,
    private accountService: AccountService,
    private utilityService: UtilityService
  ) {}

  applyClicked() {
    this.utilityService.isLoggedOut = true;
    this.accountService.getAccountLogoutRedirect().then(() => {
      var requestObj: any = {};
      requestObj.reqID = this.data.ReqID;
      requestObj.onboardingPIN = this.formData.PIN;
      this.hiringService.beginOnboardingProcess(requestObj).then((response: any) => {
        if (response != null) {
          if (response.success) {
            window.location.href = '/Careers/Tasks'; // this needs to be a page refresh, don't use angular routing here
          } else {
            this.alert = { type: 'danger', msg: response.errorMessage };
          }
        }
      });
    });
  }

  closeAlert() {
    this.alert = null;
  }

  cancelClicked = function () {
    this.activeModal.dismiss();
  };
}
